
import { useState } from 'react';
import { supabase } from '../../../lib/supabase';
import { Link, useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      console.log('Giriş denemesi başladı:', formData.email);

      const { data, error: signInError } = await supabase.auth.signInWithPassword({
        email: formData.email,
        password: formData.password
      });

      console.log('Giriş yanıtı:', { data, error: signInError });

      if (signInError) {
        console.error('Giriş hatası:', signInError);
        
        // Türkçe hata mesajları
        if (signInError.message.includes('Invalid login credentials')) {
          throw new Error('Email veya şifre hatalı. Lütfen tekrar deneyin.');
        }
        if (signInError.message.includes('Email not confirmed')) {
          throw new Error('Email adresiniz henüz onaylanmamış. Lütfen email kutunuzu kontrol edin.');
        }
        throw new Error(signInError.message);
      }

      if (data.user) {
        console.log('Kullanıcı giriş yaptı:', data.user.id);
        
        // Kullanıcı rolünü kontrol et
        const { data: profile, error: profileError } = await supabase
          .from('user_profiles')
          .select('role')
          .eq('id', data.user.id)
          .single();

        console.log('Profil bilgisi:', { profile, error: profileError });

        if (profileError) {
          console.error('Profil hatası:', profileError);
          // Profil yoksa normal kullanıcı olarak devam et
          console.log('Profil bulunamadı, ana sayfaya yönlendiriliyor');
          navigate('/');
          return;
        }

        // Admin ise dashboard'a, değilse ana sayfaya yönlendir
        if (profile?.role === 'admin') {
          console.log('Admin kullanıcı, dashboard\'a yönlendiriliyor');
          navigate('/admin/dashboard');
        } else {
          console.log('Normal kullanıcı, ana sayfaya yönlendiriliyor');
          navigate('/');
        }
      }
    } catch (error: any) {
      console.error('Giriş hatası:', error);
      setError(error.message || 'Giriş yapılırken bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  const handleGuestLogin = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4 py-12">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">Giriş Yap</h1>
          <p className="text-gray-400">Hesabınıza giriş yapın</p>
        </div>

        <div className="bg-[#1F1F1F] rounded-lg border border-gray-800 p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-lg">
                <p className="text-sm text-red-500">{error}</p>
              </div>
            )}

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Email
              </label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="w-full px-4 py-3 bg-[#171717] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#FCD34D] transition-colors text-sm"
                placeholder="ornek@email.com"
                required
                disabled={loading}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">
                Şifre
              </label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                className="w-full px-4 py-3 bg-[#171717] border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-[#FCD34D] transition-colors text-sm"
                placeholder="••••••••"
                required
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="whitespace-nowrap w-full px-6 py-3 bg-[#FCD34D] text-black font-semibold rounded-lg hover:bg-[#fcd34ddd] transition-all cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i>
                  Giriş yapılıyor...
                </span>
              ) : (
                'Giriş Yap'
              )}
            </button>
          </form>

          <div className="mt-6 space-y-4">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-700"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-2 bg-[#1F1F1F] text-gray-400">veya</span>
              </div>
            </div>

            <button
              onClick={handleGuestLogin}
              disabled={loading}
              className="whitespace-nowrap w-full px-6 py-3 bg-[#171717] text-white font-semibold rounded-lg border border-gray-700 hover:bg-[#252525] transition-all cursor-pointer disabled:opacity-50"
            >
              Misafir Olarak Devam Et
            </button>

            <div className="text-center">
              <p className="text-gray-400 text-sm">
                Hesabınız yok mu?{' '}
                <Link to="/auth/register" className="text-[#FCD34D] hover:underline">
                  Kayıt Ol
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
